export type LevelsCompletionFilter = "all" | "incomplete" | "completed";

/**
 * Derives the active completion filter from the current pathname. The index route (`.../levels`, no
 * completion segment) is "all"; the sibling routes end in `/incomplete` or `/complete`. Matching the
 * pathname (not local state) keeps both the active pill and the layout's single persistent levels
 * list correct however the route was reached — tapping a pill, the tab, or a deep link.
 */
export function completionFilterFromPathname(pathname: string): LevelsCompletionFilter {
  if (pathname.endsWith("/incomplete")) {
    return "incomplete";
  }
  if (pathname.endsWith("/complete")) {
    return "completed";
  }
  return "all";
}
